import React from 'react';
import { Table, Upload, Button, Input, Icon, Select, Card, Col, Form, Modal, Dropdown, Menu, Popconfirm, message } from 'antd';
import common from '../../assets/common.js';
import MenuAction from '../../modest/menuaction/index.js'
import UpdateModal from './updatemodal.js'
import ImportModal from './importmodal.js'
import ReleaseModal from './releasemodal.js'
import './index.css';

const FormItem = Form.Item;
const Option = Select.Option;

class MemberTable extends React.Component {
  delete = (record) => {
    var postData = {};
    postData["_url"] = "";
    postData["_method"] = "DELETE";
    postData["id"] = record.id;
    common.request(postData, this, function(obj, result){
      const pagination = obj.state.table.pagination;
      obj.getList(pagination);
    });
  }
  cancel = (id) =>{
    console.log(id)
  }
  constructor(){
    super();
    let table = {};
    table.id = "proTable";
    table = common.getDefaultTable(table);
    this.state = {
      table,
      search : "",
      modalType : "",
      modalData : "",
      visible: false,
      data: [],
      checkVisible: false,
      checkTable:[],
      faceVisible: false,
      previewVisible: false,
      previewImage: '',
      fileList: [],
      example: [1,2,3,4,5,6,238]
    }
  }
  componentWillMount(){
    this.showTableCol();
    this.setCheckTableCol();
  }
  componentDidMount(){
    // this.getList();
    // this.getBatch();
  }
  getBatch = () => {
    var postData = {};
    postData["_url"] = "batch";
    postData["_method"] = "GET";
    postData["n"] = 10;
    common.request(postData, this, function(obj, data){
      const batchId = data.retData[0].batch_id;
      obj.setState({
        batchId,
      }, function(){
        this.getList();
      });
    })
  }
  toRecord = (record) => {
    this.props.history.push("/record");
    window.localStorage.setItem('userName', record.userName);
    window.localStorage.setItem('cardNo', record.cardNo);
    window.location.reload();
  }
  setCheckTableCol = () => {
    let table = this.state.checkTable;
    table.columns = [{
      title:'区域',
      dataIndex: 'areaName',
      key:'areaName'
    }, {
      title: '楼栋',
      dataIndex: 'building',
      key: 'building'
    }, {
      title: '单元门',
      dataIndex: "roomName",
      key: "roomName"
    }, {
      title: '设备别名',
      dataIndex: 'doorName'
    }, {
      title: '状态',
      render: (text, record) => {
        return (
          <div>
            <span>{ record.status === "UN_ACTIVATED"?"未激活":"" }</span>
            <span>{ record.status === "MORMAL"?"正常":"" }</span>
            <span>{ record.status === "ACTIVATED_FAIL"?"激活失败":"" }</span>
            <span>{ record.status === "DEl"?"已删除":"" }</span>
          </div>
        )
      }
    }];
    this.setState({
      checkTable: table
    });
  }
  faceUpdate = (record) => {
    var postData = {};
    postData["_url"] = "api/dc/user";
    postData["_method"] = "GET";
    postData["id"] = record.id;
    common.request(postData, this, function(obj, data){
      // console.log(data.result.faceList);
      var fileLists = data.result.faceList.map(function(item) {
        return {uid:item.faceId,url:item.faceUrl};
      });
      // console.log(fileLists);
      obj.setState({
        faceVisible: true,
        data: record,
        fileList: fileLists
      }, function(){
      });
    })
  }
  handleChange = ({ fileList }) => {
    // console.log(fileList);
    this.setState({ fileList })
  }
  showTableCol = () => {
    let table = this.state.table;
    table.columnsList = [{
      title: '姓名',
      dataIndex: 'userName',
      must: true,
      show: true,
    }, {
      title: '性别',
      dataIndex: 'sex',
      must: false,
      show: true,
      width: '70px',
      render: (text, record) => {
        return (
          <div>
            <span>{record.gender === 1?"男":""}</span>
            <span>{record.gender === 2?"女":""}</span>
            <span>{record.gender === 0?"未知":""}</span>
          </div>
        )
      }
    }, {
      title: '部门',
      dataIndex: 'deptName',
      must: false,
      show: true,
    }, {
      title: '学号',
      dataIndex: 'cardNo',
      must: false,
      show: true,
    }, {
      title: '物理卡号',
      dataIndex: 'plasticCardNumber',
      must: false,
      show: true,
    },{
      title: '开门权限',
      must: false,
      show: true,
      align: "center",
      width: '100px',
      render: (text, record) => {
        return (
          <a onClick={ this.checkPrivileges.bind(this,"", record.userId)}>查看</a>
        )
      }
    },{
      title: '开门记录',
      dataIndex: 'updateTime',
      must: false,
      show: true,
      align: "center",
      width: '100px',
      render: (text, record) => {
        return (
          <a onClick={this.toRecord.bind(this,record)}>查看</a>
        )
      }
    },{
      title: '状态',
      must: false,
      dataIndex: 'status',
      show: true,
      width: '70px',
      render: (text, record) => {
        return (
          <span>{record.status === "VALID"?'有效':'禁用'}</span>
        )
      }
    }, {
      title: '操作',
      dataIndex: 'action',
      className:"action",
      must: true,
      show: true,
      width: '80px',
      render: (text, record) => {
        const menu = (
          <Menu>
            <Menu.Item>
              <a onClick={ this.updateUser.bind(this,record) }>修改</a>
            </Menu.Item>
            <Menu.Item>
              <a onClick={ this.disable.bind(this,record)}>{record.status === "VALID"?"禁用":"启用"}</a>
            </Menu.Item>
            <Menu.Item>
              <Popconfirm title="确定要删除此用户吗？" okText="是" cancelText="否" onConfirm={() => this.deletePeople(record)}>
                <a className="wrap">删除</a>
              </Popconfirm>
            </Menu.Item>
            <Menu.Item>
              <a onClick={ this.faceUpdate.bind(this,record) }>人脸管理</a>
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menu}>
            <div className="ant-dropdown-link">
            更多<Icon type="down" />
            </div>
          </Dropdown>
        )
      }
    }];
    table = common.getEcardTable(table);
    this.setState({ table });
  }
  updateUser = (record) => {
    this.setState({
      visible: true,
      data: record
    });
  }
  handleCancel = () => {
    this.setState({
      visible: false
    })
  }
  handleCancelCheck = () => {
    this.setState({
      checkVisible: false
    })
  }
  handleCancelFace = () => {
    this.setState({
      faceVisible: false
    })
  }
  handleOkFace = () => {
    var faceIds = [];
    var images = [];
    var that = this;
    for(var i in this.state.fileList) {
      if(that.state.fileList[i].url) {
        faceIds.push(that.state.fileList[i].uid);
      } else {
        images.push(that.state.fileList[i].response.result);
      }
    }
    // console.log(that.state.data);
    var postData = {};
    postData["_url"] = 'api/dc/user?id='+ this.state.data.id;
    postData["_method"] = 'PUT';
    postData["faceIds"] = faceIds;
    postData["imgUrls"] = images;
    postData["cardNo"] = that.state.data.cardNo;
    postData["userName"] = that.state.data.userName;
    postData["deptName"] = that.state.data.deptName;
    common.request(postData, this, function(obj, result){
      message.info("修改成功");
      obj.getList();
      obj.setState({
        faceVisible: false
      })
    },function(obj, data){
      message.warning(data.message);
    });
  }
  disable = (record) => {
    let postData = {};
    if(record.status === "VALID") {
      postData["_url"] = "api/dc/user/disable";
    } else {
      postData["_url"] = 'api/dc/user/enable';
    }
    postData["id"] = record.id;
    common.request(postData, this, function(obj, result){
      message.info("操作成功");
      obj.getList();
    },function(obj, data){
      message.warning(data.message);
    });
  }
  deletePeople = (record) => {
    let postData = {};
    postData["_url"] = 'api/dc/user?id=' + record.id;
    postData["_method"] = "DELETE";
    common.request(postData, this, function(obj, result){
      message.info("操作成功");
      obj.getList();
    },function(obj, data){
      message.warning(data.message);
    });
  }
  changePage = (pagination, filters, sorter) => {
    // console.log(pagination);
    const table = this.state.table;
    table.pagination = pagination;
    this.setState({ table })
    this.getList(pagination.current);
  }
  changePageCheckTable = (pagination, filters, sorter) => {
    const table = this.state.checkTable;
    table.pagination = pagination;
    this.setState({ checkTable:table })
    this.checkPrivileges(pagination.current,"");
  }
  thisOk = () => {
    this.getList();
  }
  getList = (pageInfo, filters, sorter) =>{
    // console.log(this.state.userName);
    const pn = pageInfo ?pageInfo: 1;
    const table = this.state.table;
    var postData = {};
    postData["_url"] = "api/dc/user/search";
    postData["pageNum"] = pn;
    if(this.state.userName !== "") {
      postData["userName"] = this.state.userName;
    }
    if(this.state.cardNo !== "") {
      postData["cardNo"] = this.state.cardNo;
    }
    if(this.state.plasticCardNumbe !== "") {
      postData["plasticCardNumber"] = this.state.plasticCardNumber;
    }
    table.loading = true;
    this.setState({ table });
    common.request(postData, this, function(obj, data){
      const result = data.result;
      obj.showList(result, pn);
    },function(obj, state){
      table.loading = false;
      obj.setState({ table });
    });
  }
  showList = (result, pn) => {
    const table = this.state.table;
    const list = result.list;
    table.loading = false;
    var dataSource = [];
    table.pagination = {
      current : pn,
      total : result.pageInfo.resultAmount,
    }
    common.eachObj(list, function(index, dataItem){
      var one = dataItem;
      one["key"] = (index + 1);
      dataSource.push(one);
    })
    table.dataSource = dataSource;
    this.setState({ table });
  }
  showCheckTable = (result, pn) => {
    const table = this.state.checkTable;
    const list = result.list;
    table.loading = false;
    var dataSource = [];
    table.pagination = {
      current : pn,
      total : result.pageInfo.resultAmount,
    }
    common.eachObj(list, function(index, dataItem){
      var one = dataItem;
      one["key"] = (index + 1);
      dataSource.push(one);
    })
    table.dataSource = dataSource;
    this.setState({ checkTable: table});
  }
  showModal = (modalType, modalData) => {
    switch(modalType){
      case "releaseend":case "importend":
        this.getList();
        this.setState({ modalType, modalData });
        break;
      default:
        this.setState({ modalType, modalData });
        break;
    }
  }
  handleSearch = (selectedKeys, confirm) => () => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }

  handleReset = clearFilters => () => {
    clearFilters();
    this.setState({ searchText: '' });
  }

  setUserName = (e) => {
    this.setState({
      userName: e.target.value
    })
    // console.log(e.target.value);
  }

  setCardNo = (e) => {
    this.setState({
      cardNo: e.target.value
    })
  }
  setPlasticCardNumber = (e) => {
    this.setState({
      plasticCardNumber: e.target.value
    })
  }
  handleSubmit = (e) => {
    let this_ = this;
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this_.submit(values);
      }
    });
  }
  checkPrivileges = (pageInfo, id) => {
    if(id !== "") {
      this.setState({ id });
    } else {
      id = this.state.id;
    }
    const pn = pageInfo ?pageInfo: 1;
    const table = this.state.checkTable;
    let postData = {};
    postData["_url"] = 'api/whitelist/search';
    postData["userId"] = id;
    postData["pageNum"] = pn;
    table.loading = true;
    this.setState({ checkTable: table });
    common.request(postData, this, function(obj, result){
      obj.setState({
        checkVisible: true
      })
      obj.showCheckTable(result.result, pn);
    },function(obj, data){
      table.loading = false;
      this.setState({ checkTable: table });
      message.warning(data.message);
    });
  }

  submit = (values) => {
    let postData = values;
    postData["_url"] = 'api/dc/user?id='+ this.state.data.id;
    postData["_method"] = 'PUT';
    if(postData["plasticCardType"] == null) {
      delete postData["plasticCardType"];
    }
    common.request(postData, this, function(obj, result){
      message.info("修改成功");
      obj.getList();
      obj.props.form.resetFields();
      obj.setState({
        visible: false
      })
    },function(obj, data){
      message.warning(data.message);
    });
  }
  changeBatch = (batchId) => {
    this.setState({ batchId }, function(){
      this.getList()
    })
  }
  render(){
    const { table, modalType, modalData, checkTable, fileList, userName, cardNo, deptName } = this.state;
    const { getFieldDecorator } = this.props.form;
    // console.log(userName);
    const hasClick = (userName && userName.length > 0 || cardNo && cardNo.length > 0 || deptName && deptName.length > 0)?true: false;
    // console.log(hasClick);
    const formItemLayout = {
      labelCol: {xs: { span: 24 },sm: { span: 6 },},
      wrapperCol: {xs: { span: 24 },sm: { span: 14 },},
    };
    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">Upload</div>
      </div>
    );
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };
    return(
      <div>
        <Card>
          <div className="table-menu clearfix">
            <div className="pull-left">
              <Col span={10} style={{marginTop:15}}>
                <label>姓&emsp;&emsp;名： </label>
                <Input style={{width:250}} placeholder="请输入姓名" onChange={this.setUserName}/>
              </Col>
              <Col span={10} style={{marginTop:15}}>
                <label>学工号： </label>
                <Input style={{width:250}} placeholder="请输入学工号" onChange={this.setCardNo}/>
              </Col>
              <Col span={10} style={{marginTop:15}}>
                <label>物理卡号： </label>
                <Input style={{width:250}} placeholder="请输入物理卡号" onChange={this.setPlasticCardNumber}/>
              </Col>
              <Col span={4} style={{marginTop:15}}>
                <Button type="primary" onClick={this.thisOk}>查询</Button>
              </Col>
            </div>
            <div className="pull-right">
              { table.show && <MenuAction obj={ this }/> }
            </div>
          </div>
          <div id="manageTableDiv" className="table-div">
            { table.show && <Table
             { ...table }
             onChange={this.changePage.bind(this)}
            />}
            {/*<div className="table-total">共{ table.pagination.total }条数据</div>*/}
          </div>
          <Modal
            title="修改信息"
            visible={this.state.visible}
            centered={true}
            className="text-center"
            onCancel={this.handleCancel}
            footer={null}
          >
            <Form onSubmit={this.handleSubmit}>
              <FormItem
                {...formItemLayout}
                label="姓名"
              >
                {getFieldDecorator('userName', {
                  rules: [{
                    required: true, message: '请填写姓名!',
                  }],
                  initialValue: this.state.data?this.state.data.userName:''
                })(
                  <Input />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="学工号"
              >
                {getFieldDecorator('cardNo', {
                  rules: [{
                    required: true, message: '请填写学工号!',
                  }],
                  initialValue: this.state.data?this.state.data.cardNo:''
                })(
                  <Input type="text" />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="部门"
              >
                {getFieldDecorator('deptName', {
                  rules: [{
                    required: true, message: '请填写施工人员所在部门!',
                  }],
                  initialValue: this.state.data?this.state.data.deptName:''
                })(
                  <Input type="text" />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="性别"
              >
                {getFieldDecorator('gender', {
                  rules: [{
                    required: true, message: '请选择性别!',
                  }],
                  initialValue: this.state.data?this.state.data.gender:''
                })(
                  <Select style={{ width: 70 }}>
                    <Option value={1}>男</Option>
                    <Option value={2}>女</Option>
                  </Select>
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="物理卡号"
              >
                {getFieldDecorator('plasticCardNumber', {
                  rules: [{
                    message: '请填写物理卡号!',
                  }],
                  initialValue: this.state.data?this.state.data.plasticCardNumber:''
                })(
                  <Input type="text" />
                )}
              </FormItem>
              {
                this.props.form.getFieldValue('plasticCardNumber') && <FormItem
                  {...formItemLayout}
                  label="实体卡类型"
                >
                  {getFieldDecorator('plasticCardType', {
                    rules: [{
                      required: false,message: '请选择实体卡类型!',
                    }],
                    initialValue: this.state.data?(this.state.example.indexOf(this.state.data.plasticCardType) < 0?null: this.state.data.plasticCardType): 1
                  })(
                    <Select style={{ width: 180 }}>
                      {this.state.example.indexOf(this.state.data.plasticCardType) < 0 &&<Option value={null}>未知</Option>}
                      <Option value={1}>身份证</Option>
                      <Option value={2}>Mifare_UltraLight</Option>
                      <Option value={3}>Mifare_One(S50)</Option>
                      <Option value={4}>Mifare_One(S70)</Option>
                      <Option value={5}>Mifare_Pro(X)</Option>
                      <Option value={6}>Mifare_DESFire</Option>
                      <Option value={238}>其他</Option>
                    </Select>
                  )}
                </FormItem>
              }
              <FormItem {...tailFormItemLayout}>
                <Button type="primary" htmlType="submit">修改</Button>
              </FormItem>
            </Form>
          </Modal>
          <Modal
            title="权限信息"
            visible={this.state.checkVisible}
            centered={true}
            className="text-center"
            onCancel={this.handleCancelCheck}
            onOk={this.handleCancelCheck}
          >
          <Table {...checkTable} onChange={this.changePageCheckTable.bind(this)}/>
          </Modal>
          <Modal
            title="人脸管理"
            visible={this.state.faceVisible}
            centered={true}
            className="text-center"
            onCancel={this.handleCancelFace}
            onOk={this.handleOkFace}
          >
            <div className='clearfix'>
              <Upload
                action="api/upload/image"
                listType="picture-card"
                fileList={fileList}
                onChange={this.handleChange}
              >
                {fileList.length >= 3 ? null : uploadButton}
              </Upload>
            </div>
          </Modal>
          { modalType.indexOf("update") >= 0  && <UpdateModal modalType={ modalType } modalData={ modalData } showModal={ this.showModal.bind(this) }/>}
          { modalType.indexOf("import") >= 0 && <ImportModal modalType={ modalType } modalData={ modalData } showModal={ this.showModal.bind(this) }/>}
          { modalType.indexOf("release") >= 0 && <ReleaseModal modalType={ modalType } modalData={ modalData } showModal={ this.showModal.bind(this) }/>}
        </Card>
      </div>
    )
  }
}
const MemberTableForm = Form.create()(MemberTable);
export default MemberTableForm;



// WEBPACK FOOTER //
// ./src/component/manage/user.js